<template lang="pug">
    .container
        .row
            .col-md-5.color-white.footer-cta-form
                h2 Let The Game Begin
                h4 Your entertainment starts here. Get the latest gaming news and deals direct to your email. Sign up for the Lair-dnd Chronicles.
                .row.g-3
                    .col-md-6.mb-2
                        re-input(label="First Name" placeholder="First Name" v-model.trim="$v.fields.first_name.$model" :validations="validations.first_name" :v="$v.fields.first_name" @input="$v.fields.first_name.$reset")
                    .col-md-6.mb-2
                        re-input(label="Last Name" placeholder="Last Name" v-model.trim="$v.fields.last_name.$model" :validations="validations.last_name" :v="$v.fields.last_name" @input="$v.fields.last_name.$reset")
                    .col-12.mb-3
                        re-input(label="Email" type="email" placeholder="Email" v-model.trim="$v.fields.email.$model" :validations="validations.email" :v="$v.fields.email" @input="$v.fields.email.$reset")
                    .col-12.mb-2
                        re-checkbox(v-model="$v.fields.subscribe.$model" :validations="validations.subscribe" :v="$v.fields.subscribe" @input="$v.fields.subscribe.$reset") By signing up, you agree to receive promotional emails. You can unsubscribe at any time. For more information, read our Terms and Conditions, Privacy Policy.
                    .col-12
                        v-button.btn.btn-primary.btn-large.color-white.mt-2(@click="subscribe" :loading="subscribing") Subscribe
                    .col-12.mt-5(v-if="subscriptionError")
                        re-toast-alert(type="danger") {{ subscriptionError }}
                    .col-12.mt-5(v-if="subscribed")
                        re-toast-alert(type="info") You are subscribed!
            .col-md-7

</template>

<script>
import ComponentMixin from 'utils/vue/mixins/components/complex'
import FormMixin from 'utils/vue/mixins/form'
import { parseValidations, setValidationRule, parseValidationSetup, email, truthyRule } from 'utils/vue/lib/validations'
import { getFirstErrorMessage } from 'utils/vue/services/main'

const VALIDATIONS = {
    first_name: setValidationRule('fields.first_name', {
        required: { error: 'First name is required' },
    }),
    last_name: setValidationRule('fields.last_name', {
        required: { error: 'Last name is required' },
    }),
    email: setValidationRule('fields.email', {
        required: { error: 'Email is required' },
        email: { rule: email },
    }),
    subscribe: setValidationRule('fields.subscribe', {
        truthy: { error: 'Please check to subscribe', rule: truthyRule }
    }),
}

export default {
    name: 'subscription-form',

    mixins: [
        ComponentMixin,
        FormMixin,
    ],

    data() { return {
        fields: {
            first_name: '',
            last_name: '',
            email: '',
            subscribe: false,
        },
        subscribed: false,
        subscribing: false,
        subscriptionError: null,
    }},

    validations() {
        return { fields: parseValidations(VALIDATIONS) }
    },

    async created() {
        this.validations = parseValidationSetup(VALIDATIONS, this)
        this.setupForm(VALIDATIONS, { first_name: '', last_name: '', email: '', subscribe: false })
    },

    methods: {
        async subscribe() {
            this.subscribed = false
            this.subscriptionError = null

            this.$v.$touch()

            if (!this.$v.$invalid) {
                try {
                    this.subscribing = true

                    const payload = {
                        email: this.fields.email,
                        first_name: this.fields.first_name,
                        last_name: this.fields.last_name,
                    }

                    await axios.post('/api/customer/mailchimp/subscribe', payload)

                    this.subscribed = true
                } catch (e) {
                    this.subscriptionError = getFirstErrorMessage(e)
                } finally {
                    this.subscribing = false
                }
            }
        },
    }
}
</script>
